export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/files/resources/components.js